import { Radio } from '@audio-network/componentlibrary'
import { FileFormat } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'

import clientGetToggleFromCookie from '@/utils/cookies/getToggleFromCookie'

import { useDownloadContext } from '../../DownloadOptionsModal.context'
import downloadOptionsStyles from '../DownloadOptions.module.css'
import {
	getFileFormatFieldName,
	getFileFormatOptionValue,
} from '../DownloadOptions.utils'
import FieldsetSection from '../FieldsetSection'

const FileFormatSection = (): JSX.Element => {
	const { setValue, watch } = useFormContext()
	const { t } = useTranslation('download')
	const { modalId } = useDownloadContext()
	const selectedFileFormat = watch('fileFormat')
	const isAiffsInDownloadModalEnabled = clientGetToggleFromCookie(
		'AIFFsInDownloadModal'
	)

	const aiff = getFileFormatOptionValue(modalId, 'aiff')
	const mp3 = getFileFormatOptionValue(modalId, 'mp3')
	const wav = getFileFormatOptionValue(modalId, 'wav')
	const fileFormatFieldName = getFileFormatFieldName(modalId)

	return (
		<FieldsetSection
			legendIcon={
				<FileFormat className={downloadOptionsStyles.fileFormatIcon} />
			}
			title={t('file-format')}
		>
			<div className={downloadOptionsStyles.fileFormatOptions}>
				<Radio
					checked={selectedFileFormat === wav}
					className={downloadOptionsStyles.fileFormatOption}
					label={t('wav')}
					name={fileFormatFieldName}
					onChange={() => setValue('fileFormat', wav)}
					value={wav}
				/>
				{isAiffsInDownloadModalEnabled && (
					<Radio
						checked={selectedFileFormat === aiff}
						className={downloadOptionsStyles.fileFormatOption}
						label={t('aiff')}
						name={fileFormatFieldName}
						onChange={() => setValue('fileFormat', aiff)}
						value={aiff}
					/>
				)}
				<Radio
					checked={selectedFileFormat === mp3}
					className={downloadOptionsStyles.fileFormatOption}
					label={t('mp3')}
					name={fileFormatFieldName}
					onChange={() => setValue('fileFormat', mp3)}
					value={mp3}
				/>
			</div>
		</FieldsetSection>
	)
}

export default FileFormatSection
